/* Lyallmills containers page — assets/lm-wholesale.js (v3) */
(function () {
  'use strict';
  var d = document;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll progress bar */
  var prog = d.createElement('div');
  prog.className = 'lmw-progress';
  d.body.appendChild(prog);
  var setProg = function () {
    var h = d.documentElement.scrollHeight - innerHeight;
    prog.style.width = (h > 0 ? (scrollY / h) * 100 : 0) + '%';
  };
  addEventListener('scroll', setProg, { passive: true }); setProg();

  /* sticky nav */
  var nav = d.getElementById('lmwNav');
  if (nav) {
    addEventListener('scroll', function () {
      nav.classList.toggle('is-on', scrollY > innerHeight * 0.72);
    }, { passive: true });
  }

  /* hero slider + captions + dot progress */
  var slides = d.querySelectorAll('.lmw-hero__slide');
  var dots = d.querySelectorAll('.lmw-hero__dot');
  var capEl = d.getElementById('lmwSlideCap');
  if (slides.length > 1) {
    var cur = 0, timer;
    var setCap = function (i) {
      if (capEl && dots[i]) capEl.textContent = dots[i].getAttribute('data-cap') || '';
    };
    var restartDot = function (i) {
      if (!dots[i]) return;
      dots[i].classList.remove('is-act');
      void dots[i].offsetWidth; /* restart CSS fill */
      dots[i].classList.add('is-act');
    };
    var go = function (i) {
      slides[cur].classList.remove('is-act');
      if (dots[cur]) dots[cur].classList.remove('is-act');
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('is-act');
      restartDot(cur);
      setCap(cur);
    };
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer); go(i);
        if (!reduced) timer = setInterval(function () { go(cur + 1); }, 6000);
      });
    });
    setCap(0);
    if (!reduced) timer = setInterval(function () { go(cur + 1); }, 6000);
  }

  /* reveal on scroll */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  d.querySelectorAll('[data-r]').forEach(function (el) { io.observe(el); });

  /* counters */
  var co = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, t = +el.getAttribute('data-count'), s = el.getAttribute('data-suffix') || '', st = null;
      var step = function (ts) {
        if (st === null) st = ts;
        var p = Math.min((ts - st) / 1600, 1);
        el.textContent = Math.floor(t * (1 - Math.pow(1 - p, 3))).toLocaleString() + s;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      co.unobserve(el);
    });
  }, { threshold: 0.6 });
  d.querySelectorAll('[data-count]').forEach(function (el) { co.observe(el); });

  /* FAQ */
  d.querySelectorAll('.lmw-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var it = q.closest('.lmw-faq__item');
      var open = it.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open);
      it.querySelector('.lmw-faq__a').setAttribute('aria-hidden', !open);
    });
  });

  /* generic horizontal slider factory (drag + arrows + snap) */
  function hslider(track, prevBtn, nextBtn, cardSel, onScroll) {
    if (!track) return;
    var step = function () {
      var c = track.querySelector(cardSel);
      return c ? c.getBoundingClientRect().width + 20 : 320;
    };
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    var dn = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) { dn = true; sx = e.clientX; sl = track.scrollLeft; track.classList.add('drag'); });
    addEventListener('pointerup', function () { dn = false; track.classList.remove('drag'); });
    addEventListener('pointermove', function (e) { if (dn) track.scrollLeft = sl - (e.clientX - sx); });
    if (onScroll) { track.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
    return { step: step };
  }

  /* 12-step process slider + progress + counter */
  var tr = d.getElementById('lmwTrack');
  if (tr) {
    var fill = d.getElementById('lmwFill');
    var cnt = d.getElementById('lmwCount');
    var total = tr.querySelectorAll('.lmw-pstep').length;
    hslider(tr, d.getElementById('lmwPrev'), d.getElementById('lmwNext'), '.lmw-pstep', function () {
      var max = tr.scrollWidth - tr.clientWidth;
      if (fill) fill.style.width = (max ? (tr.scrollLeft / max) * 100 : 0) + '%';
      if (cnt) {
        var card = tr.querySelector('.lmw-pstep');
        var w = card ? card.getBoundingClientRect().width + 20 : 320;
        var i = Math.min(total, Math.round(tr.scrollLeft / w) + 1);
        cnt.textContent = ('0' + i).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
    });
  }

  /* review / trust slider (autoplay) */
  var rt = d.getElementById('lmwRevTrack');
  if (rt) {
    var rs = hslider(rt, d.getElementById('lmwRevPrev'), d.getElementById('lmwRevNext'), '.lmw-rev__card');
    if (!reduced && rt.children.length > 1) {
      var rTimer = setInterval(function () {
        var max = rt.scrollWidth - rt.clientWidth;
        if (rt.scrollLeft >= max - 8) rt.scrollTo({ left: 0, behavior: 'smooth' });
        else rt.scrollBy({ left: rs.step(), behavior: 'smooth' });
      }, 5500);
      rt.addEventListener('pointerdown', function () { clearInterval(rTimer); });
    }
  }

  /* gallery lightbox with prev/next + counter */
  var lb = d.getElementById('lmwLbox');
  if (lb) {
    var li = d.getElementById('lmwLimg'), lc = d.getElementById('lmwLcap'), lcount = d.getElementById('lmwLcount');
    var items = Array.prototype.slice.call(d.querySelectorAll('.lmw-gitem'));
    var idx = 0;
    var show = function (i) {
      idx = (i + items.length) % items.length;
      li.src = items[idx].getAttribute('data-full');
      lc.textContent = items[idx].getAttribute('data-cap');
      if (lcount) lcount.textContent = (idx + 1) + ' / ' + items.length;
    };
    items.forEach(function (g, i) {
      g.addEventListener('click', function () { show(i); lb.classList.add('on'); });
    });
    var close = function () { lb.classList.remove('on'); };
    d.getElementById('lmwLclose').addEventListener('click', close);
    var pv = d.getElementById('lmwLprev'), nx = d.getElementById('lmwLnext');
    if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    if (nx) nx.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    addEventListener('keydown', function (e) {
      if (!lb.classList.contains('on')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* GSAP parallax (guarded) */
  if (window.gsap && window.ScrollTrigger && !reduced) {
    gsap.registerPlugin(ScrollTrigger);
    d.querySelectorAll('[data-plx]').forEach(function (img) {
      gsap.to(img, {
        yPercent: 8, ease: 'none',
        scrollTrigger: { trigger: img.closest('section,header,div'), start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  /* smooth scroll */
  d.querySelectorAll('a[href^="#lmw-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = d.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
})();
